/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreatePersonalAssetHistoryDto,
    CreatePersonalAssetHistoryDtoFromJSON,
    CreatePersonalAssetHistoryDtoToJSON,
    PersonalAssetHistoryDto,
    PersonalAssetHistoryDtoFromJSON,
    PersonalAssetHistoryDtoToJSON,
    PersonalAssetHistoryListDto,
    PersonalAssetHistoryListDtoFromJSON,
    PersonalAssetHistoryListDtoToJSON,
    UpdatePersonalAssetHistoryDto,
    UpdatePersonalAssetHistoryDtoFromJSON,
    UpdatePersonalAssetHistoryDtoToJSON,
} from '../models';

export interface PersonalAssetHistoryControllerCreateRequest {
    createPersonalAssetHistoryDto: CreatePersonalAssetHistoryDto;
}

export interface PersonalAssetHistoryControllerDeleteRequest {
    id: string;
}

export interface PersonalAssetHistoryControllerGetRequest {
    id: string;
}

export interface PersonalAssetHistoryControllerGetListRequest {
    personalAssetId: string;
    limit: number;
    offset: number;
}

export interface PersonalAssetHistoryControllerUpdateRequest {
    id: string;
    updatePersonalAssetHistoryDto: UpdatePersonalAssetHistoryDto;
}

/**
 * 
 */
export class PersonalAssetsHistoryApi extends runtime.BaseAPI {

    /**
     * Create personal asset history
     */
    async personalAssetHistoryControllerCreateRaw(requestParameters: PersonalAssetHistoryControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetHistoryDto>> {
        if (requestParameters.createPersonalAssetHistoryDto === null || requestParameters.createPersonalAssetHistoryDto === undefined) {
            throw new runtime.RequiredError('createPersonalAssetHistoryDto','Required parameter requestParameters.createPersonalAssetHistoryDto was null or undefined when calling personalAssetHistoryControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonalAssetHistoryDtoToJSON(requestParameters.createPersonalAssetHistoryDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetHistoryDtoFromJSON(jsonValue));
    }

    /**
     * Create personal asset history
     */
    async personalAssetHistoryControllerCreate(requestParameters: PersonalAssetHistoryControllerCreateRequest, initOverrides?: RequestInit): Promise<PersonalAssetHistoryDto> {
        const response = await this.personalAssetHistoryControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove personal asset history
     */
    async personalAssetHistoryControllerDeleteRaw(requestParameters: PersonalAssetHistoryControllerDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetHistoryControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Remove personal asset history
     */
    async personalAssetHistoryControllerDelete(requestParameters: PersonalAssetHistoryControllerDeleteRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.personalAssetHistoryControllerDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get personal asset history
     */
    async personalAssetHistoryControllerGetRaw(requestParameters: PersonalAssetHistoryControllerGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetHistoryDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetHistoryControllerGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetHistoryDtoFromJSON(jsonValue));
    }

    /**
     * Get personal asset history
     */
    async personalAssetHistoryControllerGet(requestParameters: PersonalAssetHistoryControllerGetRequest, initOverrides?: RequestInit): Promise<PersonalAssetHistoryDto> {
        const response = await this.personalAssetHistoryControllerGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get array of personal asset list items
     */
    async personalAssetHistoryControllerGetListRaw(requestParameters: PersonalAssetHistoryControllerGetListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetHistoryListDto>> {
        if (requestParameters.personalAssetId === null || requestParameters.personalAssetId === undefined) {
            throw new runtime.RequiredError('personalAssetId','Required parameter requestParameters.personalAssetId was null or undefined when calling personalAssetHistoryControllerGetList.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling personalAssetHistoryControllerGetList.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling personalAssetHistoryControllerGetList.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-history/list/{personalAssetId}`.replace(`{${"personalAssetId"}}`, encodeURIComponent(String(requestParameters.personalAssetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetHistoryListDtoFromJSON(jsonValue));
    }

    /**
     * Get array of personal asset list items
     */
    async personalAssetHistoryControllerGetList(requestParameters: PersonalAssetHistoryControllerGetListRequest, initOverrides?: RequestInit): Promise<PersonalAssetHistoryListDto> {
        const response = await this.personalAssetHistoryControllerGetListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update personal asset history
     */
    async personalAssetHistoryControllerUpdateRaw(requestParameters: PersonalAssetHistoryControllerUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PersonalAssetHistoryDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling personalAssetHistoryControllerUpdate.');
        }

        if (requestParameters.updatePersonalAssetHistoryDto === null || requestParameters.updatePersonalAssetHistoryDto === undefined) {
            throw new runtime.RequiredError('updatePersonalAssetHistoryDto','Required parameter requestParameters.updatePersonalAssetHistoryDto was null or undefined when calling personalAssetHistoryControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/personal-assets-history/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonalAssetHistoryDtoToJSON(requestParameters.updatePersonalAssetHistoryDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonalAssetHistoryDtoFromJSON(jsonValue));
    }

    /**
     * Update personal asset history
     */
    async personalAssetHistoryControllerUpdate(requestParameters: PersonalAssetHistoryControllerUpdateRequest, initOverrides?: RequestInit): Promise<PersonalAssetHistoryDto> {
        const response = await this.personalAssetHistoryControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
